<template>
    <div class="info-card">
        <div class="title-header">
            <img v-if="imgErrorCount < 2" class="chat-img" :src="obj.avatar" ref="groupheadImg" @error="setDefaultImg">
            &nbsp;
            <span>{{obj.roomName}}</span>
            &nbsp;
            <qrcodePopoverButton :url="roomUrl" />
        </div>
<!--        <span v-if="null != obj.groupInfo" class="des-text" v-html="obj.groupInfo"></span>-->
        <div class="des-area-box">
            <el-input type="textarea" autosize disabled v-model="obj.groupInfo" />
        </div>

<!--        <textarea :value="obj.groupInfo" class="des-area-box" disabled />-->
    </div>
</template>

<script setup>
    import qrcodePopoverButton from "@/components/shopopee/button/qrcodePopoverButton"
    import {computed, getCurrentInstance, ref} from "vue";

    const props = defineProps(["obj"])

    const { proxy } = getCurrentInstance()
    const publicPath = process.env.BASE_URL
    let imgErrorCount = ref(0)

    const roomUrl = computed(() => {
        let url = null

        if (null != props.obj.roomId){
            url = `${proxy.$ShopopeeUrl}chatroom/${props.obj.roomId}`
        }

        return url
    })

    function setDefaultImg() {
        if (imgErrorCount.value > 1){
            return
        }

        const dom = proxy.$refs.groupheadImg

        dom.src = `${publicPath}static/images/head.jpg`

        imgErrorCount.value += 1
    }

</script>

<style scoped>
    .info-card {
        text-align: left;
    }

    .chat-img {
        width: 2em;
        height: 2em;
    }

    .title-header {
        padding: 10px;
        /*border-bottom: 1px solid #e4e7ed;*/
        box-sizing: border-box;
    }

    .des-text {
        color: #606266;
    }


</style>
<style>
    .des-area-box textarea {
        width: 100% !important;
        border: 0 !important;
        background: unset !important;
        color: #606266 !important;
        -webkit-text-fill-color: #606266 !important;
        font-size: 14px !important;
        resize: none;
        box-shadow: unset !important;
        cursor: default !important;
        opacity:1
    }

    .des-area-box textarea[disabled] {
        color: #606266 !important;
        -webkit-text-fill-color: #606266 !important;
        opacity:1
    }

    .des-area-box textarea:disabled {
        color: #606266 !important;
        -webkit-text-fill-color: #606266 !important;
        opacity:1
    }
</style>